// assets/menu-parent-click.js
(function () {
  const DESKTOP = window.matchMedia('(min-width: 990px)');

  function bindParentLinks() {
    document.querySelectorAll('details > summary[data-parent-url]').forEach((sum) => {
      const details = sum.parentElement;
      sum.addEventListener('click', (e) => {
        if (!DESKTOP.matches) return; // 모바일/태블릿은 기존 펼치기 UX 유지
        const url = sum.getAttribute('data-parent-url');

        // 닫혀 있으면: 펼치기만 하고 이동 막기
        if (!details.hasAttribute('open')) {
          e.preventDefault();
          details.setAttribute('open', '');
          return;
        }
        // 이미 열려 있으면: 링크로 이동
        if (url) window.location.href = url;
      });
    });
  }

  document.addEventListener('DOMContentLoaded', bindParentLinks);
  document.addEventListener('shopify:section:load', bindParentLinks);
})();
